module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "organization",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.currentOrgId !== '') ? _c('change-admin-modal', {
    attrs: {
      "dialog": _vm.changeAdminDialog,
      "item": _vm.item,
      "organizationId": _vm.currentOrgId
    },
    on: {
      "update:dialog": function($event) {
        _vm.changeAdminDialog = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentOrgId !== '') ? _c('remove-user-modal', {
    attrs: {
      "dialog": _vm.removeUserDialog,
      "item": _vm.item,
      "organizationId": _vm.currentOrgId
    },
    on: {
      "update:dialog": function($event) {
        _vm.removeUserDialog = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentOrgId !== '') ? _c('leave-organization-modal', {
    attrs: {
      "dialog": _vm.leaveOrganizationDialog,
      "user": _vm.User,
      "organizationId": _vm.currentOrgId
    },
    on: {
      "leave-org-event": _vm.reloadInfo,
      "update:dialog": function($event) {
        _vm.leaveOrganizationDialog = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasOrganization) ? _c('remove-organization-modal', {
    attrs: {
      "dialog": _vm.removeOrganizationDialog,
      "organization": _vm.User.Organization.find(function (org) { return org.id === _vm.currentOrgId; })
    },
    on: {
      "remove-org-event": _vm.reloadInfo,
      "update:dialog": function($event) {
        _vm.removeOrganizationDialog = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": "",
      "fill-height": ""
    }
  }, [_c('p', {
    staticClass: "font title"
  }, [_c('b', [_vm._v("Organizaciones")])]), _vm._v(" "), (_vm.hasOrganization) ? _c('div', [(_vm.isAdmin(_vm.User)) ? _c('v-text-field', {
    staticClass: "font input-text",
    staticStyle: {
      "width": "87%"
    },
    attrs: {
      "readonly": !_vm.isNameEditable,
      "prepend-inner-icon": "domain",
      "append-icon": _vm.iconEdit,
      "name": "name",
      "label": "Nombre de la organización",
      "type": "name",
      "color": "0099E1"
    },
    on: {
      "click:append": _vm.editName
    },
    model: {
      value: (_vm.organizationName),
      callback: function($$v) {
        _vm.organizationName = $$v
      },
      expression: "organizationName"
    }
  }) : _c('p', {
    staticClass: "font org-name"
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("domain")]), _vm._v(" " + _vm._s(this.organizationName) + " ")], 1), _vm._v(" "), _c('v-menu', {
    staticStyle: {
      "float": "right",
      "margin-top": "-58px"
    },
    attrs: {
      "left": "",
      "transition": "slide-y-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "#7A7B7B"
    }
  }, [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.organizationsItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "append": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectOrganization(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))])], 1)]
  })], 2)], 1)], 1) : _c('p', {
    staticClass: "font org-name"
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("domain")]), _vm._v(" Sin organización ")], 1), _vm._v(" "), _c('div', {
    staticClass: "div-create-org"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require('../../assets/icons/add-organization.png')
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "font create-org-button",
    on: {
      "click": _vm.newOrganizationButton
    }
  }, [_vm._v("Nueva organización")])]), _vm._v(" "), (_vm.hasOrganization) ? _c('div', [_c('p', {
    staticClass: "font title"
  }, [_c('b', [_vm._v("Integrantes")])]), _vm._v(" "), _c('v-list', {
    staticClass: "v-list"
  }, _vm._l((_vm.usersAdminItems), function(item) {
    return _c('v-list-tile', {
      key: item.id
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v("person")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "v-list-content"
    }, [_vm._v("\n                        " + _vm._s(item.name) + " "), _c('span', {
      staticClass: "font-light"
    }, [_vm._v("- Administrador")])])], 1)
  }), 1), _vm._v(" "), _c('v-list', {
    staticClass: "v-list"
  }, _vm._l((_vm.membersItems), function(item) {
    return _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isAdmin(item)),
        expression: "!isAdmin(item)"
      }],
      key: item.id
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v("person")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "v-list-content"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), (_vm.isAdmin(_vm.User)) ? _c('v-menu', [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "color": "#7A7B7B"
      }
    }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.removeMember(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("Eliminar")])], 1), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.makeAdmin(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("Hacer Administrador")])], 1)], 1)], 1) : _vm._e()], 1)
  }), 1), _vm._v(" "), (_vm.isAdmin(_vm.User)) ? _c('div', {
    staticClass: "div-padding-left"
  }, [_c('v-icon', {
    staticClass: "valid-button"
  }, [_vm._v("person_add")]), _vm._v(" "), _c('a', {
    staticClass: "font invite-text valid-button",
    on: {
      "click": function($event) {
        return _vm.inviteButton()
      }
    }
  }, [_vm._v("Invitar integrante")])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "font title"
  }, [_c('b', [_vm._v("Equipos de Riego")])]), _vm._v(" "), (_vm.devicesItems && _vm.devicesItems.length) ? _c('v-list', {
    staticClass: "v-list"
  }, _vm._l((_vm.devicesItems), function(item) {
    return _c('v-list-tile', {
      key: item.name
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v("track_changes")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "v-list-content"
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1) : _c('div', {
    staticClass: "align-center"
  }, [_c('p', {
    staticClass: "font sin-equipos-text"
  }, [_vm._v("NO HAY EQUIPOS REGISTRADOS")])]), _vm._v(" "), (_vm.isAdmin(_vm.User)) ? _c('div', {
    staticClass: "div-create-device"
  }, [_c('img', {
    staticClass: "vertical-align-middle create-device-icon",
    attrs: {
      "src": _vm.getCreateDeviceIcon()
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "font create-device-text valid-button",
    on: {
      "click": _vm.createDeviceButton
    }
  }, [_vm._v("Agregar equipo de riego")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "div-manage-org-btn"
  }, [(_vm.isAdmin(_vm.User)) ? _c('a', {
    staticClass: "font manage-org-button",
    on: {
      "click": _vm.manageOrganization
    }
  }, [_c('u', [_vm._v("Eliminar organización")])]) : _c('a', {
    staticClass: "font manage-org-button",
    on: {
      "click": _vm.manageOrganization
    }
  }, [_c('u', [_vm._v("Abandonar organización")])])])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-906d695e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Organization.vue
// module id = 779
// module chunks = 5